import React, { useEffect } from "react";
import { Heading } from "../../design/heading";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "../../design/table";
import { useEvent } from "../../contexts/EventContext";
import CreateEventButton from "../../components/CreateEventButton/CreateEventButton";
import EventListItem from "./components/EventListIItem";
import EmptyStateView from "../../components/EmptyStateView";
import ImportButton from "../../components/ImportButton/ImportButton";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import TasksComponent from "../../components/TaskComponent/TasksComponent";
import { useMatter } from "../../contexts/MatterContext";
import ClientOnboardingDialog from "./components/ClientOnboardingDialog";
import NoMatterView from "../../components/NoMatterView";
import EventButton from "../../components/EventButton";

const EventListPage: React.FC = () => {
  const { currentMatterId } = useMatter();
  const { events, loading, error } = useEvent();

  if (!currentMatterId) {
    return <NoMatterView />;
  }

  if (loading.list) {
    return <LoadingView title="Loading Events" />;
  }

  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  return (
    <>
      <ClientOnboardingDialog />
      <div className="flex items-end justify-between gap-4">
        <Heading>Timeline</Heading>
        <div className="flex items-center gap-2">
          <EventButton date={events[0]?.eventDate ?? undefined} />
          <ImportButton />
        </div>
      </div>
      <TasksComponent taskType="event" />
      {events.length === 0 && (
        <EmptyStateView
          title="No Events"
          message="No events found. Create an event to get started."
          action={<EventButton date={undefined} />}
        />
      )}
      {events.length > 0 && (
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader>Date</TableHeader>
              <TableHeader />
              <TableHeader>Event</TableHeader>
              <TableHeader />
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((event) => {
              return <EventListItem key={event._id} event={event} />;
            })}
          </TableBody>
        </Table>
      )}
    </>
  );
};

export default EventListPage;
